import styles from './index.module.css';
import MathoLogo from '../../assets/images/matho/matho_logo.png';

const TermsandConditions = () => (
    <main className={styles.page}>
        <article className={styles.policy}>
            <header className={styles.header}>
                <div className={styles.headerSec}>
                    <h1 className={styles.title}>Terms &amp; Conditions</h1>
                    <img src={MathoLogo} alt="Matho Logo" className={styles.logo} />
                </div>
                <p className={styles.effectiveDate}>
                    <strong>Effective Date:</strong> 04/11/2026
                </p>
            </header>

            <section className={styles.section}>
                <h2>1. Acceptance of Terms</h2>
                <p>
                    By downloading and playing the App, you agree to these Terms
                    &amp; Conditions. If you do not agree, do not use the App.
                </p>
            </section>

            <section className={styles.section}>
                <h2>2. Description of Service</h2>
                <p>
                    Matho is a mathematics-based puzzle game where players are presented with a target number and must select the correct mathematical expression from a provided list that equals the target. The App is free to play but operates on an ad-supported model where users consume virtual lives and coins to play.
                </p>
            </section>

            <section className={styles.section}>
                <h2>3. Eligibility</h2>
                <p>
                    You must be at least 18 years old to play the App. By using the
                    App, you warrant that you are at least 18 years of age.
                </p>
            </section>

            <section className={styles.section}>
                <h2>4. Virtual Currency (Coins and Lives)</h2>
                <ul>
                    <li>
                        The App allows you to earn virtual &quot;coins&quot; and
                        &quot;lives&quot; by watching rewarded video advertisements.
                    </li>
                    <li>
                        These virtual items have no real-world cash value, cannot be
                        exchanged for real money, and are non-transferable.
                    </li>
                    <li>
                        We reserve the right to manage, modify, or eliminate virtual
                        items at any time, with or without notice.
                    </li>
                </ul>
            </section>

            <section className={styles.section}>
                <h2>5. Acceptable Use</h2>
                <p>
                    You agree not to exploit bugs, use cheats, or employ automated
                    systems (bots) to fraudulently generate ad impressions or
                    manipulate gameplay.
                </p>
            </section>

            <section className={styles.section}>
                <h2>6. Limitation of Liability</h2>
                <p>
                    The App is provided &quot;as is.&quot; We are not liable for any
                    damages arising from your use of the App.
                </p>
            </section>

            <section className={styles.section}>
                <h2>8. Changes to Terms</h2>
                <p>
                    We reserve the right to modify these Terms &amp; Conditions at any
                    time. Your continued use of the App constitutes acceptance of the
                    updated terms.
                </p>
            </section>

            <section className={styles.section}>
                <h2>9. Contact Us</h2>
                <p>
                    If you have any questions regarding these Terms &amp; Conditions,
                    please contact us at:
                </p>
                <address className={styles.contact}>
                    <p>
                        <strong>Email:</strong>{' '}
                        <a href="mailto:kavishka@ardillalabs.com">
                            kavishka@ardillalabs.com
                        </a>
                    </p>
                </address>
            </section>
        </article>
    </main>
);

export default TermsandConditions;